import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import Spinner from '../other/Spinner'
import NewModal from '../root/modals/NewModal'

const StatusHistoryModal = ({ isOpen, setIsOpen, history, isLoading, isError }) => {
  const { t } = useTranslation()

  return (
    <NewModal title={t('support.detail.status_history_title')} showModal={isOpen} setShowModal={setIsOpen} page="full">
      {isLoading ? (
        <div className="flex h-full items-center justify-center py-8">
          <Spinner />
        </div>
      ) : isError ? (
        <p className="py-4 text-sm text-red-600">{t('support.detail.status_history_error')}</p>
      ) : !history?.length ? (
        <p className="py-4 text-sm text-slate-500">{t('support.detail.status_history_empty')}</p>
      ) : (
        <ol className="relative ml-1 border-l-2 border-slate-200 pl-6">
          {history.map((entry, index) => (
            <li key={`${entry.created_at}-${index}`} className="relative pb-6 last:pb-0">
              <span className="absolute -left-[31px] top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-slate-50 ring-4 ring-slate-50">
                <span className="h-3 w-3 rounded-full bg-[#006EAB] ring-2 ring-sky-100" />
              </span>
              <div className="rounded-lg border border-slate-200 bg-white px-3 py-2.5 shadow-sm">
                <p className="flex flex-wrap items-center gap-2 text-sm font-semibold text-slate-900">
                  {entry.from_status?.name ? (
                    <>
                      <span className="rounded-md bg-slate-50 px-2 py-0.5 text-slate-600">
                        {entry.from_status.name}
                      </span>
                      <span className="text-slate-400">→</span>
                    </>
                  ) : null}
                  <span className="rounded-md bg-sky-100 px-2 py-0.5 text-[#006EAB]">{entry.to_status?.name}</span>
                </p>
                <p className="mt-1.5 text-xs text-slate-500">
                  {entry.changed_by_name}
                  <span className="mx-1.5 text-slate-300">•</span>
                  {format(new Date(entry.created_at), 'dd.MM.yyyy HH:mm')}
                </p>
              </div>
            </li>
          ))}
        </ol>
      )}
    </NewModal>
  )
}

export default StatusHistoryModal
